/* unplugin-vue-components disabled */import { render } from "./lockRelateAddressList.vue?vue&type=template&id=6f4510dc&scoped=true"
import script from "./lockRelateAddressList.vue?vue&type=script&lang=js"
export * from "./lockRelateAddressList.vue?vue&type=script&lang=js"

import "./lockRelateAddressList.vue?vue&type=style&index=0&id=6f4510dc&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4510dc"]])

export default __exports__